import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
} from '@angular/core';
import { BypassBlockComponent } from '@rd/core/components/bypass-block/bypass-block.component';

@Component({
  selector: 'rd-anz-bypass-block',
  templateUrl: './bypass-block.component.html',
  styleUrls: ['./bypass-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzBypassBlockComponent extends BypassBlockComponent {
  @HostBinding('class.anz-core-bypass-block') componentClass = true;

  constructor(@Inject(DOCUMENT) protected document: any) {
    super(document);
  }

  focusOnButtonElement(buttonClass: string): void {
    this.document
      .querySelector(`${buttonClass}.bypass-block-target button`)
      .focus();
  }
}
